// App-wide constants used across multiple pages.

export const INITIAL_PATIENT = {
  title: '', name: '', phone: '', dob: '', age: '', approxAge: false, gender: '', address: '', occupation: '',
  referredBy: '', aadhaar: '', notes: '', smsDnd: false, ratePlan: '',
  fatherHusbandName: '', habits: [], isPregnant: '', isBreastfeeding: '',
  patientSince: new Date().toISOString().split('T')[0],
  groups: [], tags: [],
  insurance: { companyName: '', subType: '' },
  medicalHistory: [], dentalHistory: [], currentMedicines: [], allergies: [],
  // Registration/OPD fee: filled by Step-3 block. `collect` pre-checks when
  // the clinic has the fee enabled; receptionist can waive or override.
  regFee: { collect: true, amount: '', mode: 'cash', referenceNumber: '' },
};

export const STATUS_CONFIG = {
  'Scheduled': { color:'#00a6fb', bg:'#cce5ff', textColor:'#004085', icon:'📅' },
  'PT In':     { color:'#fd7e14', bg:'#fff3cd', textColor:'#7d4800', icon:'🚶' },
  'Engage':    { color:'#6f42c1', bg:'#e2d9f3', textColor:'#3d1a78', icon:'🦷' },
  'PT Out':    { color:'#28a745', bg:'#d4edda', textColor:'#155724', icon:'✅' },
  'Cancelled': { color:'#dc3545', bg:'#f8d7da', textColor:'#721c24', icon:'✗' },
};

// Calendar slot times: 08:00 → 21:00 in 30-min increments
export const CAL_SLOTS = (() => {
  const slots = [];
  for (let h = 8; h <= 21; h++) {
    slots.push(`${String(h).padStart(2,'0')}:00`);
    if (h < 21) slots.push(`${String(h).padStart(2,'0')}:30`);
  }
  return slots;
})();

// Finer 15-min grid used when the user opts into "dense" mode. Reuses the
// same 08:00–21:00 window so existing 30-min bookings align perfectly.
export const CAL_SLOTS_15 = (() => {
  const slots = [];
  for (let h = 8; h <= 21; h++) {
    slots.push(`${String(h).padStart(2,'0')}:00`);
    if (h < 21) {
      slots.push(`${String(h).padStart(2,'0')}:15`);
      slots.push(`${String(h).padStart(2,'0')}:30`);
      slots.push(`${String(h).padStart(2,'0')}:45`);
    }
  }
  return slots;
})();
